'use strict';
import { HistoryTypes } from '../interfaces/HistoryTypes';
import { db } from './firebase'

import {
    collection,
    addDoc,
    query,
    where,
    getDocs,
} from "firebase/firestore";

const createHistory = async (history: HistoryTypes) => {
    await addDoc(collection(db, "history"), history);
};

const getHistory = async (project_id: string) => {
    const q = query(
        collection(db, `history`),
        where("project_id", "==", project_id),
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    data.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    });

    return data
};

export {
    createHistory,
    getHistory,
};
